export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44ddb84ffd06759c1a1ef'
  }
};

export const QUERY = `
  query vendorsOne ($filter: AutoFilledFilterFindOnevendorsInput!, $skip: Int, $sort: SortFindOnevendorsInput) {
    vendorsOne (filter: $filter, skip: $skip, sort: $sort) {
        email
        phone
        firstName
        lastName
        companyName
        address {
            address1
            address2
            address3
            state
            city
            zip
            country
            _id
        }
        companyId
        bpCompany
        _id
        updatedAt
        createdAt
    }
  }
`;
